import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

// Protege una ruta: exige usuario logueado y, opcionalmente, un rol permitido.
// El rol viaja en user.tipo ('llaves' | 'personal').
export default function PrivateRoute({ children, allowedRoles }) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles) {
    const rol = user.tipo;
    if (!allowedRoles.includes(rol)) {
      // redirige a su área por defecto según el rol
      return <Navigate to={rol === "personal" ? "/rutas" : "/operar"} replace />;
    }
  }

  return children;
}
